import { ACRState } from "@reducers/types/HRM/acr-state";

import { ACRActions } from "@actions/HRM/employee/acr-actions";
import {
  DELETE_ACR_HISTORY,
  GET_ACRS_HISTORY,
  CREATE_ACR,
} from "@actions/HRM/employee/types";

import { AcrType } from "@type/HRM/acr";
import {
  getFailedState,
  getRequestingState,
  getSuccessState,
  getInitialState,
} from "@utils/store";

const initialState: ACRState = {
  ...getInitialState(),
};

const resetStates = {
  createAcrSuccess: false,
  createAcrFailed: false,
  deleteAcrTableSuccess: false,
  deleteAcrTableFailed: false,
};

const ACRReducer = (state = initialState, action: ACRActions): ACRState => {
  switch (action.type) {
    case GET_ACRS_HISTORY.GET_ACR_HISTORY_REQUEST: {
      return {
        ...getRequestingState({
          ...state,
          ...resetStates,
          data: null,
          getAcrTableRequestOngoing: true,
          getAcrTableSuccess: false,
          getAcrTableFailed: false,
        }),
      };
    }

    case GET_ACRS_HISTORY.GET_ACR_HISTORY_SUCCESS: {
      const { payload } = action as any;

      return {
        ...getSuccessState({
          ...state,
          ...resetStates,
          data: payload.data,
          getAcrTableRequestOngoing: false,
          getAcrTableSuccess: true,
          getAcrTableFailed: false,
        }),
      };
    }
    case GET_ACRS_HISTORY.GET_ACR_HISTORY_FAILED: {
      return {
        ...getFailedState({
          ...state,
          ...resetStates,
          data: null,
          getAcrTableRequestOngoing: false,
          getAcrTableSuccess: false,
          getAcrTableFailed: true,
        }),
      };
    }

    // Delete
    case DELETE_ACR_HISTORY.DELETE_ACR_HISTORY_REQUEST: {
      return {
        ...getRequestingState({
          ...state,
          ...resetStates,
          deleteAcrTableRequestOngoing: true,
          deleteAcrTableSuccess: false,
          deleteAcrTableFailed: false,
        }),
      };
    }

    case DELETE_ACR_HISTORY.DELETE_ACR_HISTORY_SUCCESS: {
      const { payload } = action as any;

      const updatedData =
        state && state.data
          ? state.data.filter((item: AcrType) => item.id !== payload?.data)
          : [];

      return {
        ...getSuccessState({
          ...state,
          ...resetStates,
          data: updatedData,
          deleteAcrTableRequestOngoing: false,
          deleteAcrTableSuccess: true,
          deleteAcrTableFailed: false,
        }),
      };
    }

    case DELETE_ACR_HISTORY.DELETE_ACR_HISTORY_FAILED: {
      return {
        ...getFailedState({
          ...state,
          ...resetStates,
          data: null,
          deleteAcrTableRequestOngoing: false,
          deleteAcrTableSuccess: false,
          deleteAcrTableFailed: true,
        }),
      };
    }

    // Create
    case CREATE_ACR.CREATE_ACR_REQUEST: {
      return {
        ...getRequestingState({
          ...state,
          ...resetStates,
          createAcrRequestOngoing: true,
          createAcrSuccess: false,
          createAcrFailed: false,
        }),
      };
    }

    case CREATE_ACR.CREATE_ACR_SUCCESS: {
      const { payload } = action as any;

      const currentData = state && state.data ? state.data : [];
      const updatedData = [...currentData, payload.data];

      return {
        ...getRequestingState({
          ...state,
          ...resetStates,
          data: updatedData,
          createAcrRequestOngoing: false,
          createAcrSuccess: true,
          createAcrFailed: false,
        }),
      };
    }

    case CREATE_ACR.CREATE_ACR_FAILED: {
      return {
        ...getRequestingState({
          ...state,
          ...resetStates,
          createAcrRequestOngoing: false,
          createAcrSuccess: false,
          createAcrFailed: true,
        }),
      };
    }

    default:
      return state;
  }
};

export default ACRReducer;
